import { appEnv } from 'shared/envs'
import { type MenuItem, ProfileMenuGroup } from 'shared/types'

import { Heimdall } from '~/domains/platform/core/heimdall'

import analitica from './analitica'

export function miscellaneousProfileMenu(): MenuItem[] {
  const hasDelayPaymentsAccess = Heimdall.pass(['delay_payments_v1_pf', 'delay_payments_v1_pj'], 'some')

  return [
    {
      order: 2,
      label: 'Informe de rendimentos',
      icon: 'file-folded',
      show: true,
      onClick: () => {
        analitica.events.profileMenu.click('informe de rendimentos')
      },
      path: '/informe-de-rendimentos',
      active: (route: string) => ['/settings/report-income', '/informe-de-rendimentos'].includes(route),
      group: ProfileMenuGroup.ACCOUNT_SETTINGS
    },
    {
      order: 3,
      label: 'Contratos',
      icon: 'percent-box',
      show: true,
      onClick: () => {
        analitica.events.profileMenu.click('contratos')
      },
      path: '/contratos',
      active: (route: string) => ['/settings/contracts', '/contratos'].includes(route),
      group: ProfileMenuGroup.COMMERCIAL_CONDITIONS
    },
    {
      order: 7,
      label: hasDelayPaymentsAccess ? 'Taxas Inteligentes' : 'Taxas e tarifas',
      icon: 'circle-money',
      show: true,
      onClick: () => {
        if (hasDelayPaymentsAccess) {
          analitica.events.delayPayments.click()
          analitica.events.profileMenu.click('taxas inteligentes')
        } else {
          analitica.events.profileMenu.click('taxas e tarifas')
        }
      },
      path: hasDelayPaymentsAccess ? '/taxas-inteligentes' : '/tarifas',
      active: (route: string) =>
        ['/settings/fees', '/tarifas', '/investment/delay-payments/home', '/taxas-inteligentes'].includes(route),
      isNew: hasDelayPaymentsAccess,
      group: ProfileMenuGroup.COMMERCIAL_CONDITIONS
    },
    {
      order: 10,
      label: 'Central de ajuda',
      icon: 'circle-help',
      show: Boolean(appEnv.isProduction),
      onClick: () => {
        analitica.events.profileMenu.click('central de ajuda')

        window.open('https://ajuda.stone.com.br', '_blank')
      },
      group: ProfileMenuGroup.OTHERS
    }
  ]
}
